<article class="related-search sim-gallery">
    <div class="container">
        <div  class="simmer-animation sim-heading"></div>
        <div class="row custome-set mb-3">
            <div class="series-box" *ngFor="let number of [0,1,2,3,4,5,6,7]">
                <div class="simmer-animation series-img mb-2"></div>
                <div class="simmer-animation series-img"></div>
            </div>       
        </div>
    </div>
</article>

